import React from 'react';
import { createRoot } from 'react-dom/client';
import { Locale } from '@op/opds.opux';

import App from './App';
import { APP_ROOT_ID } from './constants/common';
import reportWebVitals from './reportWebVitals';

const appRoot = document.getElementById(APP_ROOT_ID);

const DEFAULT_LANGUAGE = 'FI'; // default to finnish?
const LOCALES = ['fi', 'en', 'sv'];

const getDefaultLocale = () => {
    const userLanguage = navigator.language;
    const browserLanguage =
        document.documentElement.getAttribute('lang') || DEFAULT_LANGUAGE;

    const locale = (userLanguage || browserLanguage)
        .substring(0, 2)
        .toLowerCase() as Locale;

    return LOCALES.includes(locale) ? locale : 'en';
};

const getLocale = () => {
    const selectedLanguage = localStorage.getItem('language');
    if (selectedLanguage) {
        return selectedLanguage as Locale;
    }
    return getDefaultLocale();
};

setupDevelopmentTools();
renderApplication();

function renderApplication() {
    if (appRoot) {
        const root = createRoot(appRoot);
        if (process.env.NODE_ENV === 'development') {
            window.reactAppRoot = root; // for local development tools
        }
        const locale = getLocale();
        document.documentElement.lang = locale; // sync cardcontext locale with document lang on application render
        root.render(<App locale={locale} />);
    }
}

function setupDevelopmentTools() {
    // Wrap development block with dev mode check - terser gets rid of this block during production build
    if (process.env.NODE_ENV === 'development') {
        import('@op/luna.local-development-environment/setup').then(
            ({ setup }) =>
                setup({ APP_ROOT_ID: APP_ROOT_ID, renderApplication }),
        );
        //supress internal opux warnings that cannot be fixed in component level
        //when new version available, check if has been fixed.
        // eslint-disable-next-line no-console
        console.warn = () => {};
    }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
